export default __webpack_public_path__ + "static/media/CUTs_image.dc8d40d1.jpg";